// console.clear();

var pym = require("./lib/pym");
var ANALYTICS = require("./lib/analytics");
require("./lib/webfonts");
var { isMobile } = require("./lib/breakpoints");

var d3 = require("d3/dist/d3.min");

var { classify, COLORS } = require("./lib/helpers");

function shuffle(array) {
  let currentIndex = array.length,  randomIndex;

  // While there remain elements to shuffle.
  while (currentIndex != 0) {

    // Pick a remaining element.
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;

    // And swap it with the current element.
    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex], array[currentIndex]];
  }

  return array;
}

var topojson = require("topojson-client/dist/topojson-client.min");
var countriesTopo = require("./data/countries.json");
var countriesData = topojson.feature(countriesTopo,countriesTopo.objects["countries"]);
var countriesNames = countriesData.features.map(c=>classify(c.properties.npr_name));

var pymChild = null;
pym.then(function(child) {
  pymChild = child;
  child.sendHeight();

  render();
  window.addEventListener("resize", render);
});

var render = function() {

  var containerElement = document.querySelector(".graphic");
  //remove fallback
  containerElement.innerHTML = "";

  var containerWidth = containerElement.offsetWidth;
  var containerHeight = containerWidth; //square aspect ratio

   var margins = {
    top: 5,
    right: 5,
    bottom: 5,
    left: 5
  };

  // Calculate actual chart dimensions
  var chartWidth = containerWidth - margins.left - margins.right;
  var chartHeight = containerHeight - margins.top - margins.bottom;


  var orthographic = d3.geoOrthographic()
        .fitSize([chartWidth,chartHeight],countriesData)
        .rotate([-31.166,-48.379]);

  var path = d3.geoPath().projection(orthographic);

  var container = d3.select(containerElement);

  var svg = container
    .append("svg")
    .attr("width", chartWidth + margins.left + margins.right)
    .attr("height", chartHeight + margins.top + margins.bottom)
    .append("g")
    .attr("transform", `translate(${margins.left},${margins.top})`);

  //base circle fill
  var circle = svg.append("circle")
                            .attr("class", "base")
                            .attr("cx", chartWidth/2)
                            .attr("cy", chartWidth/2)
                            .attr("r", chartWidth/2);


  var graticule = d3.geoGraticule()
                        .step([10, 10]);;

  var graticuleLines = svg.append("g")
                                    .append("path")
                                    .datum(graticule)
                                    .attr("class", "graticule")
                                    .attr("d", path);

  var countries = svg.append("g")
                                .selectAll(".country")
                                .data(countriesData.features)
                                .enter()
                                .append("path")
                                    .attr("class", "country")
                                    .attr("d", path)
                                    .attr("fill", "#ccc")
                                    .attr("id", d=>classify(d.properties["npr_name"]));

  //outer stroke (use for drop shadow/outer glow)
  var circle = svg.append("circle")
                            .attr("class", "outer")
                            .attr("cx", chartWidth/2)
                            .attr("cy", chartWidth/2)
                            .attr("r", chartWidth/2+1);


  //from nadieh bremer: https://www.visualcinnamon.com/2016/06/glow-filter-d3-visualization/
  //Container for the gradients
  var defs = svg.append("defs");

  //Filter for the outside glow
  var filter = defs.append("filter")
      .attr("id","glow");
  filter.append("feGaussianBlur")
      .attr("stdDeviation","3.5")
      .attr("result","coloredBlur");
  var feMerge = filter.append("feMerge");
  feMerge.append("feMergeNode")
      .attr("in","coloredBlur");
  feMerge.append("feMergeNode")
      .attr("in","SourceGraphic");

  var highlight = svg.append("g")
                        .attr("transform", `translate(${chartWidth/2},${chartHeight/2})`)
                        // .style("filter", "url(#glow");


  var colorScale = d3.scaleOrdinal()
                      .domain(["refugees", "energy", "security", "economics", "geopolitics"])
                      .range([COLORS.orange3,COLORS.teal3,COLORS.red3,"#ECA395",COLORS.blue3]);




  /////////////////////////////                         
  /////setup animation/////////
  /////////////////////////////  
  var currentCenter = [0,0];

  var annotationDiv = container.append("div")
                          .attr("class", "annotation")
                          .style("top", chartHeight/2 + "px");

  function selectHighlights(){

    //filter data to just descriptions with < 150 characters, plus has description
    //and matching record in geodata
    var data = DATA.filter(function(row){
        if(row["globe-description"] && countriesNames.indexOf(classify(row.place)) != -1){
           return row["globe-description"].length < 150;
        } else {
          return false;
        }
      });

    //check for match in geodata
    var categories = ["economics", "security", "energy", "geopolitics", "refugees"];
    shuffle(categories);
    var highlighted = [];
    var countriesUnique = [];

    for(var category of categories){
        var cat = data.filter(row=> (row["category"] == category) && (countriesUnique.indexOf(row.place) == -1) );
        var highlight = cat[Math.floor(Math.random()*cat.length)];
        highlighted.push(highlight);
        countriesUnique.push(highlight.place)
    }
    return highlighted;
  }

  var highlights = selectHighlights();
  var highlightIndex = 0;
  updateMap(highlights[highlightIndex]);

  
  function updateMap(current){

    var country = countriesData.features.filter(c=> classify(c.properties["npr_name"]) == classify(current.place))[0];
    var centroid;
    if(current["map-coordinates"]) {
      console.log(current["map-coordinates"]);
      centroid = JSON.parse(current["map-coordinates"]);
      // console.log(centroid);
    } else {
      //calculate centroid
      centroid = d3.geoCentroid(country);
      // console.log(centroid);
    }
    //get data
    // var country = countriesData.features.filter(c=> classify(c.properties["npr_name"]) == classify(current.place))[0];

    //set colors for countries
    countries.transition().duration(500)
                .attr("fill", function(d){
                    if(classify(d.properties["npr_name"]) == classify(current.place)){
                      return "#999";
                    } else {
                      return "#ccc";
                    }
                  });


    annotationDiv.transition().duration(500)
              .style("opacity", 0).on("end",function(){
                annotationDiv.html(null);
              });

    //fade out previous highlight and remove
    highlight.transition().duration(500)
              .attr("opacity", 0).on("end",function(){
                highlight.html();
              });


    //rotate to centroid
    d3.transition().duration(1500)
        .tween("rotate", function(){
          var r = d3.interpolate(orthographic.rotate(), [-centroid[0],-centroid[1]]);
          return function(t){
            orthographic.rotate(r(t));
            svg.selectAll("path").attr("d", path);
          }
        }).on("end", function(){
            setTimeout(function(){
              highlightIndex++;
              if(highlightIndex==highlights.length) highlightIndex = 0;
              updateMap(highlights[highlightIndex]);
            },2500)
        })

      //fade in new annotation
      setTimeout(function(){
        //add highlight and fade in
        highlight.append("circle")
                    .attr("cx", 0)
                    .attr("cy", 0)
                    .attr("r", 5)
                    .attr("fill", d => colorScale(current.category))
                    .attr("stroke", "#fff")
                    .attr("stroke-width", 0.75);                    

        highlight.transition().duration(500)
                    .attr("opacity", 1);


        //add annotation and fade in
        var annotationText = `<div class="header">
                          <b>${current.place}</b>
                          | 
                          <b class="${current.category}">${CATEGORIES[current.category]}</b>
                          </div>
                          <div class="description">
                          <p>${current["globe-description"]}</p>
                          </div>`;

        annotationDiv.html(annotationText);

        annotationDiv.transition().duration(500)
                      .style("opacity", 1);

      },1000)

    currentCenter = centroid;
    
  }


  // //bring highlighted country on top
  // if(highlight){
  //   d3.select(".country.highlight").raise();
  // }


  pymChild.sendHeight();
};